export default __webpack_public_path__ + "static/media/hp-2.9bb81d75.png";